import { createSelector } from '@reduxjs/toolkit';
import { getContactsAsUsers } from './get-contacts-as-users';
import { getCurrentUserEmail } from '../session';
import { _sortByValue } from '../utilities/_sortByValue';
import { isCurrentUser } from '../utilities/isCurrentUser';

export const getContactsWithAccessForAccessControl = createSelector(
  getContactsAsUsers,
  getCurrentUserEmail,
  (contacts, currentUserEmail) =>
    contacts
      .filter((c) => c.accessLevel === 'READONLY' || c.accessLevel === 'USER')
      .map((c) => ({
        id: c.uuid,
        value: c.name + ' (' + c.partnerName + ')',
        disabled: isCurrentUser(c.email, currentUserEmail),
      }))
      .sort(_sortByValue),
);
